<template>

    <div>

        <div class="px-6 py-4 bg-minplan-beige -mb-4">
            <page-title :title="$t('templates.copyTemplate')"></page-title>
        </div>

        <jet-form-section @submitted="copyTemplate">

            <template #form>

                <form-card :title="$t('templates.template')" :description="$t('templates.templateDescription')">
                    <div class="col-span-6">
                        <label for="name" class="block text-sm font-medium text-gray-700">{{
                                $t("templates.name")
                            }}</label>
                        <input type="text" name="name" id="name" v-model="form.name"
                               class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                               autofocus />
                        <jet-input-error :message="form.errors.name" class="mt-2" />
                    </div>

                </form-card>

            </template>

            <template #actions>
                <div class="flex justify-end my-4 mx-6">

                    <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">{{ $t('actions.cancel') }}</button>

                    <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3">
                        {{ $t("actions.save") }}
                    </primary-button>

                </div>
            </template>

        </jet-form-section>
    </div>
</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";

export default defineComponent({
    props: ['template'],
    layout: MainLayout,
    inheritAttrs: false,
    emits: ["closeModal"],
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        copyTemplate() {
            this.form.post(this.route("advisors.templates.copy", this.template.uuid), {
                preserveScroll: true
            });
        }
    },
    setup() {
        const form = useForm({
            name: null
        });

        return { form };
    }
});
</script>

<style scoped></style>
